import { Directive, SkipSelf } from "@angular/core";
import { IOnModelChange } from "../../common-form.interface";
import { CommonFieldManagerDirective } from "../../field-manager.directive";

@Directive({
    selector: "[common-switch-actions]",
    exportAs: "SwitchActions",
})
export class CommonSwitchActionsDirective implements IOnModelChange {

    constructor(
        @SkipSelf() public fieldManager: CommonFieldManagerDirective,
    ) { }

    public get stateProp() {
        return this.fieldManager.context.stateProp;
    }

    public onModelChange(state, e?) {
        if (e) { e.stopPropagation(); }
        this.fieldManager.dispatchFieldUpdate(state);
        this.fieldManager.dispatchFormFieldChange(state);
    }
}
